<mat-button-toggle-group [hideSingleSelectionIndicator]="true" #group="matButtonToggleGroup" (change)="onCurrencyChange(group.value)">
    <mat-button-toggle value="USD" [checked]="currency === 'USD'">USD</mat-button-toggle>
    <mat-button-toggle value="local" [checked]="currency === 'local'">Local</mat-button-toggle>
</mat-button-toggle-group>